import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteTenantStart, getAllOrganizationsStart, resetStates } from "../../../Store/Slices/organizationSlice";
import Loader from "../../../Components/Loader";
import Pagination from "../../../Components/formModules/Pagination";
import { AgGridReact } from "@ag-grid-community/react";
import { useNavigate } from "react-router-dom";
import { Utils } from "../../../Utils";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import Toast from "../../../Components/Toast";

const AllOrganizations = () => {
    let gridRef = useRef();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    let orgData = useSelector((state) => state?.org);
    console.log('org data:', orgData)

    let [searchData, setSearchData] = useState([]);
    let [value, setValue] = useState('');
    let [currentPage, setCurrentPage] = useState(1);
    let [pageSize, setPageSize] = useState(10);
    let [showAlertModal, setShowAlertModal] = useState(false);
    let [tenantData, setTenantData] = useState({
        id: '',
        name: ''
    })

    const SwitchCellRenderer = (params) => {
        return (
            <>
                {params?.data?._id !== '6763c15b097862b8d4c4e6e5' &&
                    <span class="cursor-pointer" style={{ color: 'rgb(220, 53, 69)' }}>
                        <i class="fas fa-trash" onClick={() => {
                            setTenantData({ id: params?.data?._id, name: params?.data?.organizationName })
                            setShowAlertModal(true)
                        }} />
                    </span>
                }
            </>
        );
    };

    let [columnDefs] = useState([
        {
            headerName: "Company Name",
            valueGetter: (params) => `${params.data.organizationName || ''}`
        },
        {
            headerName: "Phone No",
            valueGetter: (params) => `${params.data.Phone || ''}`
        },
        {
            headerName: "Access URL",
            valueGetter: (params) => `${params?.data?.access_url || ''}`
        },
        {
            headerName: "Recent Login",
            valueGetter: (params) => `${params?.data?.lastLoginAt || ''}`
        },
        { headerName: "Action", field: "isActive", cellRenderer: SwitchCellRenderer }
    ]);

    useEffect(() => {
        dispatch(getAllOrganizationsStart({ page: currentPage, count: pageSize }))
    }, [])

    useEffect(() => {
        if (orgData?.allOrgList?.length) {
            setSearchData(orgData?.allOrgList)
        }
    }, [orgData?.allOrgList])

    useEffect(() => {
        dispatch(getAllOrganizationsStart({ page: currentPage, count: pageSize }))
    }, [pageSize, currentPage])

    useEffect(() => {
        if (orgData?.deleteStatus === true) {
            dispatch(getAllOrganizationsStart({ page: currentPage, count: pageSize }))
            toast.success(orgData?.message, {
                autoClose: 2000,
                onClose: () => {
                    setTenantData({ id: '', name: '' })
                    dispatch(resetStates())
                }
            });
        }
        if (orgData?.deleteStatus === false) {
            toast.error(orgData?.message, {
                autoClose: 2000,
                onClose: () => {
                    setTenantData({ id: '', name: '' })
                    dispatch(resetStates())
                }
            });
        }
    }, [orgData.deleteStatus])

    const handleSearch = (e) => {
        const { value } = e?.target;
        setValue(value)
        const filteredData = orgData?.allOrgList?.filter((item) =>
            item?.organizationName?.toLowerCase()?.includes(value.toLowerCase()) ||
            item?.Phone?.includes(value.toLowerCase()) ||
            item?.access_url?.toLowerCase()?.includes(value.toLowerCase())
        );
        setSearchData(filteredData);
    }

    const handlePrevPage = () => {
        setCurrentPage((prev) => Math.max(prev - 1, 1));
    };

    const handleNextPage = () => {
        let totalPages = Math.ceil(orgData?.totalOrgCount / pageSize);
        setCurrentPage((prev) => Math.min(prev + 1, totalPages));
    };

    const handlePageSizeChange = (size) => {
        setPageSize(size);
        setCurrentPage(1);
    };

    const deleteTenant = () => {
        dispatch(deleteTenantStart(tenantData?.id))
    }

    return (
        <>
            <Loader isVisible={orgData?.isLoading} />
            <Toast />
            <div className="security-ctrl profile-set overflow-y-auto">
                <div className="pt-2">
                    <h5 className="fw-semibold">All Companies</h5>
                </div>

                <div className="d-flex align-items-center justify-content-between py-4">
                    <div className="d-flex align-items-start">
                        <div className="search-box border rounded-pill">
                            <label htmlFor="userSearch" className="searchbutton bg-white" type="button"><i className="fa-solid fa-magnifying-glass"></i></label>
                            <input type="search" placeholder="Search Company" id="userSearch" className="searchfield bg-white"
                                value={value} onChange={handleSearch}
                            />
                        </div>
                    </div>
                    <div className="d-flex align-items-end">
                        <button type="button" class="btn btn-primary rounded-pill btn-blue"
                            onClick={() => navigate(Utils.getNavigationUrl("settings/company-settings"))}
                        ><span>Back</span></button>
                    </div>
                </div>

                <div className="col-md-12">
                    {orgData?.allOrgList?.length && <div className="ag-theme-quartz" style={{ height: 450, display: "flex", flexDirection: "column", position: "relative" }}>
                        <AgGridReact
                            ref={gridRef}
                            rowData={searchData || []}
                            rowCount={1000}
                            columnDefs={columnDefs}
                            defaultColDef={{
                                filter: 'agTextColumnFilter',
                                floatingFilter: true,
                            }}
                            rowSelection="single"
                            pagination={false}
                            paginationPageSize={pageSize}
                            paginationPageSizeSelector={[10, 25, 50]}
                            rowHeight={46}
                        />
                        <Pagination
                            currentPage={currentPage}
                            pageSize={pageSize}
                            totalCount={orgData?.totalOrgCount}
                            onPageSizeChange={handlePageSizeChange}
                            onPrevPage={handlePrevPage}
                            onNextPage={handleNextPage}
                        />
                    </div>}
                </div>

                <Modal
                    show={showAlertModal}
                    onHide={() => setShowAlertModal(false)}
                    backdrop="static"
                    keyboard={false}
                    className="modal-md"
                >
                    <Modal.Body>
                        <h4 className='pb-3'>Delete Company</h4>
                        <p className='fw-semibold'>
                            Are you sure you want to delete this company <b>{tenantData?.name}</b>?
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            type="button"
                            className="btn btn-outline-secondary rounded-pill flat-btn text-secondary"
                            onClick={() => { setTenantData({ id: '', name: '' }); setShowAlertModal(false) }}
                            data-bs-dismiss="modal">
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-danger rounded-pill btn-blue"
                            data-bs-dismiss="modal"
                            onClick={() => { deleteTenant(); setShowAlertModal(false) }}>
                            Yes, Delete
                        </button>
                    </Modal.Footer>
                </Modal>
            </div >
        </>
    )
}
export default AllOrganizations;